import React, { useState, useEffect, useCallback } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { Link, useNavigate } from 'react-router-dom';
import { LiquidButton } from './animate-ui/components/buttons/liquid';

const API_BASE = "https://7oduilb7tc.execute-api.us-east-1.amazonaws.com";
const STAGE = window.location.hostname === 'test.dopove.com' ? 'test' : 'prod';
const API_URL = `${API_BASE}/${STAGE}/waitlist`;

export default function SmartWaitlistButton({ size = "lg", className = "" }) {
  const [userEmail, setUserEmail] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [waitlistStatus, setWaitlistStatus] = useState({ joined: false, loading: true });
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();
  const checkIfSignedIn = useCallback(async () => {
    try {
      const attrs = await fetchUserAttributes();
      setUserEmail(attrs.email);
      setUserInfo(attrs);
      checkWaitlist(attrs.email);
    } catch (err) {
      // Not signed in
      setWaitlistStatus({ joined: false, loading: false });
    }
  }, []);

  useEffect(() => {
    checkIfSignedIn();
  }, [checkIfSignedIn]);

  const checkWaitlist = async (email) => {
    try {
      const response = await fetch(`${API_URL}?email=${email}`);
      const data = await response.json();
      setWaitlistStatus({ joined: data.joined, loading: false });
    } catch (err) {
      setWaitlistStatus({ joined: false, loading: false });
    }
  };

  const handleSmartJoin = async () => {
    if (!userEmail) {
       navigate('/auth');
       return;
    }
    
    if (waitlistStatus.joined) {
       navigate('/profile');
       return;
    }

    if (userInfo.email_verified !== 'true') {
       alert("SECURITY ALERT: Cannot join waitlist. Your global identity (email) must be verified in your Profile first.");
       navigate('/profile');
       return;
    }

    setProcessing(true);
    try {
      await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: userEmail,
          name: userInfo.name || userInfo.username || 'Dopove Node'
        })
      });
      navigate('/profile'); // Redirect to profile to see the fancy badge
    } catch (error) {
      console.error("Waitlist join error:", error);
      setProcessing(false);
    }
  };

  if (waitlistStatus.loading) {
     return <LiquidButton size={size} className={className}>Initializing...</LiquidButton>;
  }

  if (!userEmail) {
     return (
       <Link to="/auth" className={`inline-block ${className}`}>
         <LiquidButton size={size}>Join waitlist</LiquidButton>
       </Link>
     );
  }

  if (waitlistStatus.joined) {
    return (
       <div className={`inline-block ${className}`}>
         <LiquidButton size={size} disabled={true}>Joined</LiquidButton>
       </div>
    );
  }

  return (
    <div onClick={handleSmartJoin} className={`inline-block cursor-pointer ${className}`}>
      <LiquidButton size={size}>{processing ? 'Processing...' : 'Join waitlist'}</LiquidButton>
    </div>
  );
}
